module.exports = __webpack_public_path__ + "img/16581271_S.4fac79c9.png";